import { Component, OnInit } from '@angular/core';
import {Shared} from "@rubii/frontend-common";

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  shared = Shared;

  constructor() { }

  ngOnInit() {
  }

}
